import ProcessDispenseButton from '@/components/orders/tables/delivery-tables/open-orders/ProcessDispenseButton';
import { DeliveryTableDataProvider } from '@/context/orders/DeliveryTableFilteredData';
import { ListOrdersView } from '@/hooks/orders/useListOrders';
import DeliveryTables from '../DeliveryTables';

function OpenOrdersTables() {
  return (
    <DeliveryTableDataProvider view={ListOrdersView.Open}>
      <DeliveryTables HeaderActions={<ProcessDispenseButton />} />
    </DeliveryTableDataProvider>
  );
}

export default OpenOrdersTables;
